import { render, staticRenderFns } from "./CTA.vue?vue&type=template&id=6f21e3aa&scoped=true&"
import script from "./CTA.vue?vue&type=script&lang=js&"
export * from "./CTA.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./CTA.vue?vue&type=style&index=0&id=6f21e3aa&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6f21e3aa",
  "25dc05a1"
  
)

export default component.exports